export type CommodityType = {
  CommodityTypeId: number | null;
  CommodityTypeName: string;
  IsSystemType: boolean;
  IsActive: boolean;
};

export const COMMODITY_TYPE_INITIAL_VALUES: CommodityType = {
  CommodityTypeId: null,
  CommodityTypeName: "",
  IsSystemType: false,
  IsActive: true,
};
